import { produce } from 'immer';
import { timesheetRowQueryKey, timesheetRowsQueryKey } from './query-key';
export function getTimesheetRowsQueryData(queryClient, id) {
    return queryClient.getQueryData(timesheetRowsQueryKey(id));
}
export function invalidateTimesheetRowsQuery(queryClient, id) {
    return queryClient.invalidateQueries({ queryKey: timesheetRowsQueryKey(id) });
}
export function invalidateTimesheetRowQuery(queryClient, id, timesheetRowId) {
    return queryClient.invalidateQueries({
        queryKey: timesheetRowQueryKey(id, timesheetRowId),
    });
}
export const setTimesheetRowQueryData = (queryClient, id, timesheetRowId, updater) => {
    queryClient.setQueryData(timesheetRowQueryKey(id, timesheetRowId), (old) => produce(old, updater));
    setTimesheetRowsQueryData(queryClient, id, (draft) => {
        if (!draft)
            return draft;
        for (const row of [...draft, ...draft.flatMap((r) => r.children || [])]) {
            if (row.id === timesheetRowId) {
                updater(row);
            }
        }
        return draft;
    });
};
export const setTimesheetRowsQueryData = (queryClient, id, updater) => {
    return queryClient.setQueryData(timesheetRowsQueryKey(id), (old) => produce(old, updater));
};
//# sourceMappingURL=query.js.map